import { useState, useEffect } from 'react';
import { fetchCluster, deleteUndone } from '../../../api/api.js';

const useProblem = () => {
    const [loading, setLoading] = useState(true);
    const [checkExp, setCheckExp] = useState(false);
    const [checkStand, setCheckStand] = useState(false);
    const [cluster, setCluster] = useState(null);

    useEffect(() => {
      (async () => {
        await deleteUndone();
        const result = await fetchCluster();
        setCluster(result);
        setLoading(false);
      })();
    }, []);

    // useEffect(() => {
    //   if (problems[0] !== undefined) {
    //     setCluster(problems[0].cluster);
    //     console.log('cluster', problems[0].cluster);
    //   }
    // }, [problems]);

    const handleReload = async () => {
      await deleteUndone();
      const result = await fetchCluster();
      setCheckExp(false);
      setCheckStand(false);
      setCluster(result);
    };

    return { handleReload, loading, cluster, checkExp, checkStand, setCheckExp, setCheckStand }
}

export default useProblem;
